import { sentenceCase } from 'sentence-case';

export const isEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isPostcode = /^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}$/i;

export const isPhone = /^(\+44|0)7\d{3} ?\d{3} ?\d{3}$/;

export const isUsername = /^(?=.{6,20}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?![_.])$/i;

export const isValidUrl = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/i;

export const isMatch = (pattern, name) => RegExp(`.*${pattern.split('').join('.*')}.*`, 'i').test(name);

export const swapDate = birthdate => {
  const [d, m, y] = fixMaskDate(birthdate).split('/');
  return new Date(Number(y), Number(m) - 1, Number(d)).getTime();
};

export const getUnit = unit => {
  switch (unit) {
    case 'g':
      return 'g';
    case 'ml':
      return ' ml';
    default:
      return ` ${sentenceCase(unit || '')}`;
  }
};

export const fixMaskDate = wrongFormat => {
  const date = wrongFormat.replace(/\//g, '');
  return `${date.slice(0, 2)}/${date.slice(2, 4)}/${date.slice(4)}`;
};

export const validateBirthdate = birthdate => {
  const date = swapDate(birthdate);
  const startOfYear2000 = 949363200000;
  return !!date && date < Date.now() && date > startOfYear2000;
};

export const validateDeliverByDate = deliverByDate => {
  const date = swapDate(deliverByDate);
  const next10Days = Date.now() + 10 * 24 * 60 * 60 * 1000;
  const next10Years = Date.now() + 10 * 365 * 24 * 60 * 60 * 1000;
  return !!date && date > next10Days && date < next10Years;
};
